import client from '../../utils/client';
import { endPoints } from '../../constants/configuration';

export const getDataConfigv1Api = async ({ tenantId, authToken, userId, params }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(`${endPoints.beki}${endPoints.dataConfig}`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getInfoDetailsApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`${endPoints.beki}${endPoints.dataConfig}v2/infoicon`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDataConfigApi = async ({ tenantId, authToken, userId, params }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(`${endPoints.beki}${endPoints.dataConfig}v2${endPoints.variable}`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postDataConfigApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().post(`${endPoints.beki}${endPoints.dataConfig}v2${endPoints.variable}`,payload, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};